<template>
    <div class="w-full">
        <vs-tabs alignment="fixed">
            <vs-tab v-for="lang in langs" :key="lang" :label="lang" class="px-0">
                <div class="w-full">
                    <div class="my-3">
                        <vs-checkbox v-model="inputs[lang].visibility">{{$t('Visivel')}}</vs-checkbox>
                    </div>
                    
                    <div class="mb-3">
                        <vs-input class="w-full" v-model="inputs[lang].name" size="medium" :label="$t('nome')"/>
                    </div>

                    <div class="mb-3">
                        <vs-input class="w-full" v-model="inputs[lang].name_print" size="medium" :label="$t('Nome_Impressão')"/>
                    </div>

                    <div class="mb-3">
                        <vs-textarea class="w-full" v-model="inputs[lang].description" size="medium" :label="$t('Descrição')"></vs-textarea>
                    </div>

                    <div>
                        <vs-textarea class="w-full" v-model="inputs[lang].information" size="medium" :label="$t('Informação')"></vs-textarea>
                    </div>
                </div>
            </vs-tab>
        </vs-tabs>

        <vs-divider />

        <div class="mb-3">
        </div>

        <div class="vx-col w-full">
            <small class="block mt-3">{{$t('Moeda')}}</small>
            <v-select class="vue-select sm:w-full lg:w-1/4" :clearable="false" :searchable="false" v-model="coin_selected" :options="moedas" label="moeda">
            </v-select>

            <small class="block mt-3">{{$t('Armazém')}}</small>
            <v-select class="vue-select sm:w-full lg:w-1/4" :clearable="false" :searchable="false" v-model="warehouse" :options="warehouses" label="armazem">
            </v-select>

            <small class="block mt-3">{{$t('Categoria')}}</small>
            <v-select class="vue-select sm:w-full lg:w-1/4" :clearable="false" :searchable="false" v-model="categoria" :options="categoria_options" :label="'categoria_pt'">
            </v-select>
        </div>

        <div class="w-full mt-4">
            <vs-checkbox v-model="visibility">{{$t('Visivel')}}</vs-checkbox>
        </div>  

        <vs-divider />

        <div v-if="original_image !== null && original_image.length > 0">
            <vs-button class="sm:w-full lg:w-1/5" type="border" color="danger" v-on:click="removeFile()">{{$t('Remover_Imagem')}}</vs-button>

            <div class="mt-3 sm:w-full lg:w-1/4">
                <img class="responsive upload_image" :src="original_image" alt="">
            </div>
        </div>

        <div v-else>  
            <vs-button v-if="files['thumbnail_files'].length == 0" class="sm:w-full lg:w-1/5" type="border" color="primary" v-on:click="addFiles('thumbnail_files')">{{$t('Adicionar_Imagem')}}</vs-button>

            <vs-button v-if="files['thumbnail_files'].length > 0" class="sm:w-full lg:w-1/5" type="border" color="danger" v-on:click="removeFile(0, 'thumbnail_files')">{{$t('Remover_Imagem')}}</vs-button>

            <input v-show="false" type="file" id="files" ref="thumbnail_files" multiple v-on:change="handleFileUploads('thumbnail_files')"/>

            <div class="mt-3 sm:w-full lg:w-1/4" v-for="(file, key) in files['thumbnail_files']" :key="key">
                <img class="responsive upload_image" :src="generateImgPath(file)" alt="">
            </div>
        </div>

        <div class="mt-5">
			<vs-button class="sm:w-full lg:w-1/5" color="success" type="filled" v-on:click="submitMenu('thumbnail_files')">{{$t('Gravar')}}</vs-button>
		</div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
    props: [
        'hotel_id',
        'type_selected',
        'warehouses',
        'menu'
    ],
    data() {
        return {            
            inputs: null,
            image_deleted: 0,
            chapter: '',
            coin_selected: '',
            information: '',
            description: '',
            price: '',
            visibility: 0,
            files: {
                thumbnail_files: []
            },
            langs: ['PT', 'BR', 'EN', 'FR', 'DE', 'ES'],
            id: 0,
            moedas: ['Euro', 'Real', 'Dollar'],
            categoria: null,
            categoria_options: [],
            user: JSON.parse(window.localStorage.getItem('userSession')),
            warehouse: '',
            updateMode: false,
            original_image: '',
            dimension_error: false,
            tmp_file: '',
            created: false
        }
    },
    methods: {
        /*
        * Adds a file
        */  
        addFiles(file_type) {
            if (this.files[file_type].length > 0) {
                return;
            }
            this.$refs[file_type].click();
        },

        /*
        * Removes a select file the user has uploaded
        */  
        removeFile(key, file_type) {
            if(typeof key !== 'undefined') {
                this.files[file_type].splice(key, 1);
                this.$refs[file_type].value = '';
            }
            this.image_deleted = 1,
            this.original_image = '';
        },

        checkImgDimensions(file) {
            let img = document.createElement("IMG");
            img.src = URL.createObjectURL(file);
            img.id = 'tmp_file';
            let tmp_img = document.body.appendChild(img);
        
            setTimeout(() => {
                if(tmp_img.naturalWidth != 800 && tmp_img.naturalHeight != 600) {
                    this.dimension_error =  true;
                } else {
                    this.dimension_error =  false;
                    this.tmp_file = file;
                }

                document.getElementById("tmp_file").remove();
            }, 1000);
        },
        reset_inputs: function() {
            this.inputs = {
                'PT': {
                    name: '',
                    name_print: '',
                    description: '',
                    information: '',
                    visibility: 0,
                },
                'BR': {
                    name: '',
                    name_print: '',
                    description: '',
                    information: '',
                    visibility: 0,
                },
                'EN': {
                    name: '',
                    name_print: '',
                    description: '',
                    information: '',
                    visibility: 0,
                },
                'FR': {
                    name: '',
                    name_print: '',
                    description: '',
                    information: '',
                    visibility: 0,
                },
                'DE': {
                    name: '',
                    name_print: '',
                    description: '',
                    information: '',
                    visibility: 0,
                },
                'ES': {
                    name: '',
                    name_print: '',
                    description: '',
                    information: '',
                    visibility: 0,
                }
            }
        },
        handleFileUploads(file_type) {
            let uploadedFiles = this.$refs[file_type].files;
            let image = new Image();
            let that = this;

            image.onload = function() {
                if(this.width != 800 && this.height != 600) {
                    that.dimension_error = true;
                } else {
                    that.dimension_error = false;
                }
            }

            //Adds the uploaded file to the files array
            for( var i = 0; i < uploadedFiles.length; i++ ) {
                // Tests if the uploaded file has the right extension
                if ( /\.(jpe?g|png|gif)$/i.test( uploadedFiles[i].name ) ) {
                    this.checkImgDimensions(uploadedFiles[i]);

                    if (uploadedFiles[i].size > 200000){
                        this.$vs.notify({
                            time: 4000,
                            text: this.$t('O_tamanho_máximo_permitido_para_a_imagem_é_de'),
                            color:'danger',
                            position:'bottom-right',
                            iconPack: 'feather',
                            icon:'icon-alert-triangle'
                        });

                        this.$refs[file_type].value = '';

                        return false;
                    }

                    setTimeout(() => {
                        if(this.dimension_error == true) {
                            this.$vs.notify({
                                time: 4000,
                                text: this.$t('As_dimensões_da_imagem_devem_ser_800px_x_600px'),
                                color:'danger',
                                position:'bottom-right',
                                iconPack: 'feather',
                                icon:'icon-alert-triangle'
                            });

                            this.$refs[file_type].value = '';

                            return false;
                        }
                                            
                        this.files[file_type].push(this.tmp_file);
                        this.image_deleted = 0;
                    }, 1000);	
                } else {
                    this.$vs.notify({
                        time: 4000,
                        text: this.$t('Imagens_devem_ser_do_tipo_jpg_jpeg_png_ou_gif'),
                        color:'danger',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-alert-triangle'
                    });
                }
            }
        },

        submitMenu(file_type) {
            if(this.created == true) {
                this.$vs.notify({
                    time: 4000,
                    text: this.$t('Esta_carta_já_foi_registada'),
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-alert-triangle'
                });

                return false;
            }

            let that = this;

            if (this.validations(file_type)) {
                this.$vs.loading();

                let formData = new FormData();

                // Fill the form information to send backend
                formData.append('type', this.type_selected);
                formData.append('hotel_id', this.hotel_id);
                formData.append('name', this.name);
                formData.append('visibility', +this.visibility);
                formData.append('currency', this.coin_selected);     
                formData.append('warehouse_id', this.warehouse.cod_armazem);
                formData.append('image_deleted', this.image_deleted);
                formData.append('categoria', this.categoria.categoria_id);

                if (this.files[file_type]) {
                    formData.append('files', this.files[file_type][0]);
                }

                formData.append('description', this.description);
                formData.append('information', this.information);
                
                formData.append('inputs', JSON.stringify(this.inputs));

                let createUrl = '/myvilagale/hotel/' + this.hotel_id + '/menu?token=' + this.user.usertoken;

                let updateUrl = '/myvilagale/hotel/menu/update/' + this.menu.id + '?token=' + this.user.usertoken;

                this.$api.post(that.updateMode ? updateUrl : createUrl,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': 'Bearer ' + this.user.usertoken
                    }

                })
                .then(function(res) {
                    that.$vs.loading.close();
                    that.$vs.notify({
                        time: 4000,
                        text: that.updateMode ? that.$t('Registo_alterado_com_sucesso') : that.$t('Registo_criado_com_sucesso'),
                        color:'success',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-check'
                    });

                    if(that.updateMode == false) {
                        that.created = true;
                        that.$emit('edit-finished');
                    }
                    that.$emit('hideType');
                    that.reset_inputs();
                })
                .catch(function() {
                    that.$vs.loading.close();
                    that.$vs.notify({
                        time: 4000,
                        text: that.updateMode ? that.$t('Ocorreu_um_erro_ao_alterar_o_registo') : that.$t('Ocorreu_um_erro_ao_criar_o_registo'),
                        color:'danger',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-alert-triangle'
                    });
                });
            } else {
                this.$vs.loading.close();
            }
        },

        validations(file_type) {
            let mandatory_langs = {
                'PT': 'portugal',
                'BR': 'brasil'
            };
            let hotels = JSON.parse(localStorage.getItem('hotels'));
            let hotel_selected = hotels.find((h, k) => h.id == this.hotel_id);

            let errors = [];

            for(let lang in this.inputs) {
                if(typeof mandatory_langs[lang] !== 'undefined') {
                    if(hotel_selected.country.toLowerCase() === mandatory_langs[lang] && this.inputs[lang].name == '') {
                        errors.push(this.$t('O_campo_Nome_é_obrigatório_no_idioma')+' ' + lang + '.');
                    }
                }
            }

            if(!this.coin_selected) {
                errors.push(this.$t('O_campo_Moeda_é_obrigatório'));
            }

            if(!this.warehouse) {
                errors.push(this.$t('O_campo_Armazém_é_obrigatório'));
            }

            if(this.categoria == null) {
                errors.push(this.$t('O_campo_Categoria_é_obrigatório'));
            }

            if(errors.length > 0) {
                for(let i = 0; i < errors.length; i++) {
                    this.$vs.notify({
                        time: 4000,
                        text: errors[i],
                        color:'danger',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-alert-triangle'
                    });
                }
                return false;
            }
            return true;
        },
        getFiltros(){
            let that = this;
            this.$api({
                method: 'get',
                url: '/myvilagale/hotel/getFiltroCartas',
                params: {
                    token: this.user.usertoken,
                    // category_type: this.$route.meta.category_type
                }
            })
            .then((res) => {
                that.categoria_options = res.data;
            })
            .catch((err) => {
                that.$vs.notify({
                    text: that.$t('Ocorreu_um_erro'),
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-alert-triangle'
                });
            }).then(() => {
                that.$vs.loading.close();
            });
        }
    },
    watch: {
        /*warehouse: function(new_val, old_val) {
            console.log(new_val);
            this.getSellableItems(this.hotel_id, new_val.cod_armazem);
        }*/
    },
    created: function() {
        this.getFiltros();
        this.reset_inputs();
        if (this.menu != '') {
            this.updateMode = true;

            this.menu.idiomas.forEach(idioma => {
                this.langs.forEach(lang => {
                    if(idioma.language == lang) {
                        idioma.visibility = parseInt(idioma.visibility) == 1 ? true : false;
                        this.inputs[lang] = idioma;
                    }
                });
            });

            this.coin_selected = this.menu.currency;
            
            this.visibility = Number(this.menu.visibility);
            this.warehouse = this.warehouses.find((item, idx) => item.cod_armazem == this.menu.warehouse_id);
            // this.getSellableItems(this.hotel_id, this.warehouse.cod_armazem);

            this.type = this.menu.type;
            this.type_selected = this.menu.type;
            this.hotel_id = this.menu.hotel_id;
            this.original_image = this.menu.image_path;
            this.categoria = this.menu.categoria;
        }
    },
    mounted() {
    },
    components: {
        draggable
    }
}
</script>

<style scoped>
    @media only screen and (min-width: 400px) {
        .radios{
            display: flex;
        }
    }
    #tmp_file {
        display: none !important;
    }

    .name_block {
		display: flex;
	}

	.input_name {
		width: 75%;
		margin-top: 25px;
	}

	.input_description {
		width: 75%;
	}

	.input_chapter{
		width: 60%;
	}

	.description_block {
		display: flex;
	}

	.chapters_block {
		display: flex;
	}

	.dropdown_label_description {
		margin-top: 25px;
	}

	.input_information {
		width: 75%;
	}

	.information_block {
		display: flex;
	}
</style>